import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('RouteStateService', RouteStateService);

    function RouteStateService($state, $filter) {
        /**
         * Checks different routes for activity. They could be not
         * related in parent-children order.
         */
        this.isActive = function (routePaths: Array<string>): boolean {
            return routePaths.some(function (path) {
                return $filter('includedByState')(path);
            });
        };

        /**
         * Checks all routes for activity in parent-children order.
         */
        this.isChildrenActive = function (parentRoutePath: string): boolean {
            return $state.includes(parentRoutePath);
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/active-state.service.ts